import { render, staticRenderFns } from "./LowGradeReportForms.vue?vue&type=template&id=5bfe3642&scoped=true&"
import script from "./LowGradeReportForms.vue?vue&type=script&lang=js&"
export * from "./LowGradeReportForms.vue?vue&type=script&lang=js&"
import style0 from "./LowGradeReportForms.vue?vue&type=style&index=0&id=5bfe3642&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfe3642",
  null
  
)

export default component.exports